import React, { useEffect, useState } from 'react';
import definicoescliente from '../../definicoes-cliente.json';

const videoUrls = [
  '/video/hero4vid2.mp4',
  '/video/hero4vid.mp4',
];

const getVideoAleatorio = () => {
  const randomIndex = Math.floor(Math.random() * videoUrls.length);
  return videoUrls[randomIndex];
};

const DadosHero = {
  Titulo: 'Proteção Veicular',
  Texto: 'Garanta a segurança do seu veículo com nossa assistência e planos personalizados. Confie em quem entende de proteção!',
  TextoBotao: 'Seja um Associado',
};

const Hero = () => {
  const [currentVideo, setVideoAtual] = useState('');

  useEffect(() => {
    setVideoAtual(getVideoAleatorio());
  }, []);

  return (
    <div className="relative mx-auto px-5 overflow-x-hidden lg:overflow-x-visible" style={{ height: '100vh' }}>
      <video
        className="absolute inset-0 w-full h-full object-cover"
        src={definicoescliente?.Hero?.Video || currentVideo}
        autoPlay
        loop
        muted></video>
      <div className="absolute inset-0 bg-theme-primary opacity-20"></div>
      <section className="relative grid grid-cols-none lg:grid-cols-2 lg:pl-14 items-center h-full">
        <div className="lg:w-5/6 order-2 lg:order-none mt-20 p-10">
          <h1 className="text-3xl xl:text-5xl font-bold font-theme-heading text-theme-white text-center lg:text-start">
            {definicoescliente?.Hero?.Titulo || DadosHero.Titulo}
          </h1>
          <p className="lg:text-lg mt-10 font-theme-content text-theme-white max-w-xl text-center lg:text-start">
            {definicoescliente?.Hero?.Descricao || DadosHero.Texto}
          </p>
          <div className="flex justify-center lg:justify-start mt-10">
            <div className="uppercase text-textopadrao bg-theme-secondary px-6 py-2 text-theme-white rounded shadow-md hover:filter hover:brightness-90 border-2 border-transparent cursor-pointer transition duration-200">
            <a href={definicoescliente.Hero.LinkBotao || "#download"} target="_blank" rel="noopener noreferrer">{definicoescliente?.Hero?.NomeBotao || DadosHero.TextoBotao}</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Hero;
